import {Button} from "primereact/button";

import {ALL_SOURCES} from "@reva/shared/parameter-resolution";

import {getResourceColor} from "./paramHooks";

const getValue = (value, emptyString) => (value === "empty" ? emptyString : value);

export default function InputNumberConflictOptions({
    hasConflict,
    className,
    allValues,
    onChange,
    fmtNumber,
    emptyString,
}) {
    if (!hasConflict) return null;

    const optionColors = ALL_SOURCES.filter((source) => allValues[source] != null).map((source) => ({
        value: getValue(allValues[source], emptyString),
        color: getResourceColor(source, false, source === "immodrop"),
    }));
    const addonClassName = `p-inputgroup-addon bg-surface-0 dark:bg-surface-900 !p-1 min-w-max border-r-0 border-${className}`;

    return (
        <div className={addonClassName} data-pr-position="top">
            {optionColors.map(({color, value}) => (
                <Button
                    key={value}
                    className={`p-button-sm border-0 px-2 mx-1 py-1 font-medium ${color ? `bg-${color}` : ""}`}
                    onClick={() => onChange({target: {value: value}})}
                    disabled={value === emptyString}
                >
                    {fmtNumber ? fmtNumber(value) : value}
                </Button>
            ))}
        </div>
    );
}
